import { motion, useReducedMotion } from "framer-motion";
import { cn } from "@/lib/utils";
import { EASE, viewport } from "@/lib/motion";

export const Reveal = ({ children, className = "", delay = 0, y = 28, once = true, ...rest }) => {
  const reduce = useReducedMotion();
  return (
    <motion.div
      className={className}
      initial={reduce ? false : { opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ ...viewport, once }}
      transition={{ duration: 0.9, ease: EASE, delay }}
      {...rest}
    >
      {children}
    </motion.div>
  );
};

/**
 * Line-by-line mask reveal for headlines.
 * lines: array of strings or nodes
 */
export const MaskLines = ({ lines, className = "", lineClassName = "", delay = 0, as: Tag = "h1", inView = true, stagger = 0.09 }) => {
  const reduce = useReducedMotion();
  const anim = reduce ? {} : inView
    ? { initial: "hidden", whileInView: "show", viewport }
    : { initial: "hidden", animate: "show" };
  return (
    <Tag className={cn("headline", className)}>
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden pb-[0.06em] -mb-[0.06em]">
          <motion.span
            className={cn("block will-change-transform", lineClassName)}
            variants={{ hidden: { y: "110%" }, show: { y: "0%" } }}
            transition={{ duration: 1, ease: EASE, delay: delay + i * stagger }}
            {...anim}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </Tag>
  );
};

/** Draws a horizontal hairline from left to right when in view */
export const DrawLine = ({ className = "", dark = false, delay = 0 }) => {
  const reduce = useReducedMotion();
  return (
    <motion.div
      aria-hidden="true"
      className={cn("h-px w-full origin-left", dark ? "bg-paper/20" : "bg-ink/20", className)}
      initial={reduce ? false : { scaleX: 0 }}
      whileInView={{ scaleX: 1 }}
      viewport={viewport}
      transition={{ duration: 1.2, ease: EASE, delay }}
    />
  );
};
